import React, { useState, useEffect } from 'react';

const FlyingFish = () => {
  // Generate random initial values
  const randomHeight = Math.random() * 35 + 50; // Random height between 0% and 100%
  const randomSpeed = Math.random() * -10 - 5; // Random speed between 2 and 7 units per interval

  const [speed, setSpeed] = useState(randomSpeed);
  const [positionX, setPositionX] = useState(window.innerWidth * Math.random());
  const [positionY, setPositionY] = useState(randomHeight); // Random vertical position (static)

  useEffect(() => {
    const interval = setInterval(() => {
      setPositionX((oldPosition) => oldPosition + speed);
    }, 16);

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [speed]);

  useEffect(() => {
    if (positionX <= Math.random() * -200 - 200) {
      setSpeed(Math.random() * -10 - 5);
      setPositionX(
        () => window.innerWidth + Math.random() * window.innerWidth + 200
      ); // Reset to start off-screen again
      setPositionY(Math.random() * 35 + 50);
    }
  }, [positionX, setSpeed, setPositionY]);

  return (
    <img
      className="flying-fish"
      style={{
        position: 'fixed',
        transform: `translate(${positionX}px, ${positionY}%)`,
        transition:
          positionX < window.innerWidth ? 'left 0.016s linear' : 'none' // Smooth transition for horizontal movement
      }}
      src={require('../asset/img/fish.png')}
      alt="flying fish"
    />
  );
};

export default FlyingFish;
